import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
const _hoisted_1 = { class: "main-content" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "mt-4" };
const _hoisted_4 = {
    key: 1,
    class: "blank-box"
};
import { computed, onMounted, onUnmounted, } from 'vue';
import { routeName } from '@/constants/routeName';
import { useRoute, useRouter, } from 'vue-router';
import { userPermission } from '@/constants';
import BasicInfo from '@V/HubManagement/HubDetail/BasicInfo.vue';
import WorkerOperationSetting from '@V/HubManagement/HubDetail/WorkerOperationSetting.vue';
import AdjustmentOperationSetting from '@V/HubManagement/HubDetail/AdjustmentOperationSetting.vue';
import CardSection from '@/components/Common/CardSection.vue';
import hubDetailPageTypeOption from '@/constants/hubManagement/hubDetailPageTypeOption';
import vuexStore from '@/vuex-store';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const comp = {
            BasicInfo,
            WorkerOperationSetting,
            AdjustmentOperationSetting,
        };
        const getComp = (n) => comp[n];
        const route = useRoute();
        const router = useRouter();
        function routerPush(name, values) {
            const { params, query } = values;
            router.push({
                name,
                params,
                query,
            }).catch(() => { });
        }
        function handleClickReturnBtn() {
            const to = routeName.HUB_MANAGEMENT;
            const value = {
                query: route.query,
                params: {},
            };
            routerPush(to, value);
        }
        function handleClickEditBtn(type) {
            const to = routeName.HUB_MANAGEMENT_EDIT;
            const value = {
                params: {
                    hubId: route.params.hubId,
                    pageType: type,
                },
                query: route.query,
            };
            routerPush(to, value);
        }
        const isDistUser = computed(() => vuexStore.getters['user/isDistUser']);
        const isPermittedEditHubInfo = computed({
            get() {
                return [
                    userPermission.P_EDIT_HUB,
                ];
            },
            set() { },
        });
        const hubInfo = computed(() => vuexStore.state.hubManagement.hubDetail.hubInfo);
        const setPageTitle = () => vuexStore.dispatch('app/setPageTitle');
        const getHubInfo = (payload) => vuexStore.dispatch('hubManagement/hubDetail/getHubInfo', payload);
        const resetHubInfo = () => vuexStore.dispatch('hubManagement/hubDetail/resetHubInfo');
        const init = async () => {
            const { hubId } = route.params;
            await getHubInfo(hubId);
            setPageTitle();
        };
        onMounted(() => {
            init();
        });
        onUnmounted(() => {
            // https://barogo.slack.com/archives/C02GJBMBU6B/p1692609412734329?thread_ts=1692609202.132179&cid=C02GJBMBU6B
            // 라이더관리/상점관리와 마찬가지로 전에 남겨진 과거 허브 내역이 현재 진입한 허브내역으로 변경되기 전 보이므로 초기화시키기
            resetHubInfo();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_ui_permission = _resolveDirective("ui-permission");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(hubDetailPageTypeOption), ({ title, cardName, type }) => {
                        return (_openBlock(), _createBlock(CardSection, {
                            key: title,
                            title: title,
                            m0: ""
                        }, {
                            titleContent: _withCtx(() => [
                                (isDistUser.value)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                        key: 0,
                                        class: "option-ctrl-area",
                                        onClick: ($event) => (handleClickEditBtn(type))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { small: "" }, {
                                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                                    _createTextVNode(" mdi-pencil-outline ")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [0]
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])), [
                                        [_directive_ui_permission, isPermittedEditHubInfo.value],
                                        [
                                            _directive_btn_style,
                                            void 0,
                                            "config",
                                            {
                                                info: true,
                                                outlined: true,
                                                "size-m": true
                                            }
                                        ]
                                    ])
                                    : _createCommentVNode("v-if", true)
                            ]),
                            default: _withCtx(() => [
                                (hubInfo.value)
                                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComp(cardName)), {
                                        key: 0,
                                        "hub-info": hubInfo.value,
                                        class: "brg-input-section-dense-wrapper"
                                    }, null, 8 /* PROPS */, ["hub-info"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createCommentVNode("총판 계정만 목록보기 버튼을 노출한다"),
                    (isDistUser.value)
                        ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            class: "list-btn",
                            onClick: handleClickReturnBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                        : (_openBlock(), _createElementBlock("div", _hoisted_4))
                ])
            ]));
        };
    }
});
